import { ProDatePicker } from '@bedrock/eed-react';
import dayjs from 'dayjs';
import React from 'react';
import { FC } from 'react';
import { isNil } from 'lodash';

const formatDate = (date: string) => {
  return date ? dayjs(date).format('YYYY年MM月DD日') : '-';
};

const renderDateRange = (value: any) => {
  if (
    isNil(value) ||
    typeof value !== 'object' ||
    isNil(value?.startAt) ||
    isNil(value?.endAt)
  ) {
    return '-';
  }
  return (
    <span>{`${formatDate(value?.startAt)} ~ ${formatDate(value?.endAt)}`}</span>
  );
};

export const ProCustomFieldDateRange: FC<any> = (props) => {
  const render = (value: any) => {
    return renderDateRange(value);
  };
  return (
    <ProDatePicker
      {...props}
      fieldProps={{ range: true }}
      render={render}
      renderFormItem={(
        _value: string,
        { mode }: any,
        dom: any,
        changeData: any
      ) => {
        if (mode === 'diff-change') {
          const { oldValue, newValue } = changeData;

          return (
            <div>
              <div>{renderDateRange(newValue)}</div>
              <div className="line-through text-[var(--text-color-fademore)]">
                {renderDateRange(oldValue)}
              </div>
            </div>
          );
        }

        return (
          <span
            className={
              mode === 'diff-delete'
                ? 'line-through text-[var(--text-color-fademore)]'
                : ''
            }
          >
            {renderDateRange(changeData ?? _value)}
          </span>
        );
      }}
    />
  );
};
